import React from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import feature1 from "../../assets/images/feature-1.png";
import feature2 from "../../assets/images/feature-2.png";
import feature3 from "../../assets/images/feature-3.png";
import feature4 from "../../assets/images/feature-4.png";
import google from "../../assets/images/google-logo.svg";
import { IoStarSharp } from "react-icons/io5";
import { GoDash } from "react-icons/go";

import { Button } from "antd";
import {
  MdOutlineArrowForwardIos,
  MdOutlineArrowBackIos,
} from "react-icons/md";
import styled from "styled-components";
import { green } from "../../constants/colors";
import CustomRating from "../../components/rating";

const sliderItems = [
  {
    image: feature1,
    alt: "feature 1",
    text: "Great Services!",
    description: `"Drvico-Agency to the actively encourage customers to leave reviews to the help promote their products and services."`,
    name: "Nowry Jahan",
  },
  {
    image: feature2,
    alt: "feature 2",
    text: "Trusted Company",
    description: `"Drvico-Agency cutomer feedback is an invauable source of information that can help businesses improve their offerings and provide better experiences."`,
    name: "John Abraham",
  },
  {
    image: feature3,
    alt: "feature 3",
    text: "Trusted Company",
    description: `"Drvico-Agency cutomer feedback is an invauable source of information that can help businesses improve their offerings and provide better experiences."`,
    name: "John Abraham",
  },
];

const CustomButtonGroupContainer = styled.div`
  position: absolute;
  bottom: -23px;
  right: 0;
  left: 0;
  display: flex;
  justify-content: space-between;
  gap: 20px;
  width: 100%;
  padding: 0 9px;
  ${({ landing }) =>
    landing &&
    `
  justify-content: end;
    top: -100px;
    bottom:unset;
    border-radius: 10px;
    `}

  @media (max-width: 768px) {
    top: -60px;
    justify-content: center;
  }
`;

const CustomButton = styled(Button)`
  background-color: transparent;
  border-radius: 100%;
  height: 35px;
  width: 35px;
  font-size: 18px;
  text-align: center;
  color: lightgray !important;
  padding: 5px !important;
  color: #333;
  transition: all 0.3s ease-in-out;
  border-color: ${green} !important;

  &:hover {
    background-color: ${green} !important;
    border-color: ${green} !important;
    color: white !important;

    svg {
      color: white !important;
    }
  }
`;

const CustomButtonGroup = ({ next, previous, landing }) => {
  return (
    <CustomButtonGroupContainer
      landing={landing}
      className="custom-button-group"
    >
      <CustomButton onClick={previous} className="custom-prev-button">
        <MdOutlineArrowBackIos style={{ color: green }} />
      </CustomButton>
      <div className="text-center md:text-unset md:flex items-center gap-2">
        <p className="text-[14px] md:text-[16px] tracking-wide">
          Thousand of People Reviews to Us
        </p>
        <Button
          style={{
            background: "transparent",
            border: "none",
            boxShadow: "none",
            fontWeight: 500,
            color: green,
          }}
        >
          View All Review
        </Button>
      </div>
      <CustomButton onClick={next} className="custom-next-button">
        <MdOutlineArrowForwardIos style={{ color: green }} />
      </CustomButton>
    </CustomButtonGroupContainer>
  );
};

const SlideContainer = styled.div`
  overflow: hidden;
  width: 100%;
  display: flex;
  justify-content: center;
  :hover & {
    cursor: pointer;
  }
`;

const SlideContent = styled.div`
  padding: 6px 0;
  width: 97% !important;
  border-radius: 10px;
  padding: 50px 30px;
  margin: 0 auto;
  background: #faf8fb;
  border: 1px solid #faf8fb;
  transition: transform 0s ease-in-out;
  ${SlideContainer}:hover & {
    border: 1px solid ${green};
    cursor: context-menu;
  }
`;

const ReviewsSlider = ({ landing }) => {
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: landing ? 3 : 2,
      slidesToSlide: 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 768 },
      items: 2,
      slidesToSlide: 1,
    },
    mobile: {
      breakpoint: { max: 767, min: 250 },
      items: 1,
      slidesToSlide: 1,
    },
  };
  return (
    <div className="parent" style={{ position: "relative" }}>
      <Carousel
        responsive={responsive}
        autoPlay={true}
        swipeable={true}
        draggable={true}
        showDots={false}
        infinite={true}
        partialVisible={false}
        customButtonGroup={<CustomButtonGroup landing={landing} />}
        renderButtonGroupOutside={true}
        arrows={false} // Hide the default arrows
      >
        {sliderItems.map((item, index) => (
          <SlideContainer key={index}>
            <SlideContent>
              <div className="flex justify-between items-center">
                <div>
                  {index === 0 ? (
                    <CustomRating google="true" feedback="true" />
                  ) : (
                    <CustomRating feedback="true" />
                  )}
                  <h3 className="text-[16px]">{item.text}</h3>
                </div>
                <div>
                  {index === 0 ? (
                    <img src={google} alt="" />
                  ) : (
                    <p className="font-[500] text-[18px] flex gap-[1px] items-center justify-center">
                      <IoStarSharp
                        style={{
                          fontSize: "24px",
                          color: green,
                          marginTop: "-6px",
                        }}
                      />
                      <span>Trustpilot</span>
                    </p>
                  )}
                </div>
              </div>
              <p className="text-[18px] mb-2 mt-4">{item.description}</p>
              <p className="text-[16px] font-[500] flex items-center gap-2">
                <GoDash />
                {item.name}
              </p>
            </SlideContent>
          </SlideContainer>
        ))}
      </Carousel>
    </div>
  );
};

export default ReviewsSlider;
